import { createAuthClient } from 'better-auth/react';
import { inferAdditionalFields, genericOAuthClient } from 'better-auth/client/plugins';
import { apiBaseUrl } from './api';
import { recoverFromAuthRedirect, responseIsProxyRedirect } from './session-recovery';

export const authClient = createAuthClient({
  baseURL: `${window.location.origin}${apiBaseUrl}/auth`,
  fetchOptions: {
    credentials: 'include',
    // The 30s session poll is the main background caller on an idle tab, and it does
    // not go through api(), so recover here too when the forward-auth proxy starts
    // redirecting its requests to SSO (see session-recovery.ts).
    onResponse: (ctx) => {
      if (responseIsProxyRedirect(ctx.response)) {
        void recoverFromAuthRedirect(true);
      }
    },
    onError: (ctx) => {
      // Only act on network-level failures (blocked cross-origin redirect), not
      // ordinary JSON error responses which carry a real status.
      if (!ctx.response || ctx.response.status === 0) {
        void recoverFromAuthRedirect(false);
      }
    },
  },
  // Keep useSession() fresh so admin-driven role/status changes show up
  // without a manual refresh. Server-side cookieCache also has a short TTL,
  // so the refetched session reflects the new value within ~30s.
  sessionOptions: {
    refetchInterval: 30,
    refetchOnWindowFocus: false,
  },
  plugins: [
    inferAdditionalFields({
      user: {
        role: { type: 'string', defaultValue: 'consultant' },
        // Company a `client` represents; null for admin/consultant. Provisioned
        // server-side, surfaced on the session so the UI can scope client views.
        companyId: { type: 'string', required: false },
      },
    }),
    genericOAuthClient(),
  ],
});

export const PLATFORM_OAUTH_PROVIDER_ID = 'toptal-platform';

export const { useSession, signIn, signUp, signOut } = authClient;
